import { AgxApi } from '../../helpers/http';

export const realEstateApi = (authToken: string) =>
  new AgxApi('realestate', authToken);
